"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDraft = exports.Vehicle = void 0;
const class_transformer_1 = require("class-transformer");
const Base_1 = require("./Base");
class Vehicle extends Base_1.BaseModel {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(Vehicle, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
exports.Vehicle = Vehicle;
class VehicleDraft {
}
exports.VehicleDraft = VehicleDraft;
